import { render, staticRenderFns } from "./AprovacaoPix.vue?vue&type=template&id=ed442004&"
import script from "./AprovacaoPix.vue?vue&type=script&lang=js&"
export * from "./AprovacaoPix.vue?vue&type=script&lang=js&"
import style0 from "./AprovacaoPix.vue?vue&type=style&index=0&id=ed442004&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports